import type { SearchResult } from '~/types/fulltextSearch';
import { SEARCH_RESULT_TO_ROUTE_MAP } from './constants';

export const resultNavigationPath = (result: SearchResult) => {
  const routeConfig = SEARCH_RESULT_TO_ROUTE_MAP[result.type];
  if(!routeConfig) return;

  const { route, paramMapping } = routeConfig;

  return {
    name: route,
    params: {
        [paramMapping.routeParam]: result[paramMapping.resultField]
    }
  };
};
